import React from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {navigateToUrl, buildUrlOpenPageSelfAndRestBlank} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import {setSelfcareSubscriber} from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import {ErrorsEnum} from '../Enums/ErrorsEnum';
import AlertIcon from './../Screens/ErrorPage/Images/error.svg';
import FinancialErrorIcon from './../Screens/ErrorPage/Images/payment.svg';
import FuntoneButton from '../Components/FuntoneButton/FuntoneButton';
import {setCurrentScreen, ScreensEnum} from '../FuntoneSlice';

export const ErrorContent = (props) => {
  const {errorReason, selectedSubscriber} = props.funtoneSlice;
  const dispatch = props.dispatch;
  
  // Navigate to catalog page
  const navigateToCatalog = () => {
    if (dispatch) {
      dispatch(setCurrentScreen(ScreensEnum.CATALOG));
    }
  };
  
  // Intentionally silent in production
  const createLinkAction = (text, onClick, index = 'default', dispatchSubscriber = false) =>
    text && (
      <span key={index} className='link-action' onClick={onClick}>
        {text}
      </span>
    );

  const errorContentMap = {
    [ErrorsEnum.DATA_ONLY]: {
      icon: AlertIcon,
      title: <>מנוי {selectedSubscriber} הינו מנוי דאטה</>,
      subtitle: (
        <>
          אפשר להתחבר לשירות המתנה נעימה
          <br />
          רק באמצעות מנוי מלא
        </>
      ),
      finishButton: <BtnWhiteBlackBorderBigSize text={'הבנתי, תודה'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.IN_TRANSFER]: {
      icon: AlertIcon,
      title: <>מנוי {selectedSubscriber} נמצא בניוד</>,
      subtitle: (
        <>
          כדי להמשיך את הפעולה,
          <br />
          יש להשלים את תהליך הניוד
        </>
      ),
      finishButton: <BtnWhiteBlackBorderBigSize text={'הבנתי, תודה'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.SUSPENDED]: {
      icon: AlertIcon,
      title: <>מנוי {selectedSubscriber} מושהה</>,
      subtitle: <>לא ניתן להשלים את הפעולה</>,
      action: <FuntoneButton text={'להתקשר לנציג'} variant={'secondary'} onClick={() => {}} />,
      finishButton: <BtnWhiteBlackBorderBigSize text={'הבנתי, תודה'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN]: {
      icon: AlertIcon,
      title: (
        <>
          מנוי {selectedSubscriber} מושהה בעקבות
          <br />
          דיווח על אובדן או גניבה
        </>
      ),
      subtitle: <>לא ניתן להשלים את הפעולה</>,

      action: <FuntoneButton text={'תתקשרו אלי'} variant={'secondary'} onClick={() => {}} />,
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לעדכן אמצעי תשלום בסלקום
        </>
      ),
      action: createLinkAction('לעדכון אמצעי תשלום', () => buildUrlOpenPageSelfAndRestBlank(Config.updatePaymentMethodLink)),
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.FINANCIAL_DEBT_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לשלם את החוב בחשבון
        </>
      ),
      action: createLinkAction('לתשלום החשבון', () => buildUrlOpenPageSelfAndRestBlank(Config.payDebtLink)),
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.FINANCIAL_PAYMENT_UPDATE_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לשלם את החוב בחשבון
          <br />
          ולעדכן אמצעי תשלום
        </>
      ),
      action: (
        <div className={'action-container action-links-container'}>
          {createLinkAction('לתשלום חוב', () => buildUrlOpenPageSelfAndRestBlank(Config.payDebtLink))}
          {createLinkAction('לעדכון אמצעי תשלום', () => buildUrlOpenPageSelfAndRestBlank(Config.updatePaymentMethodLink))}
        </div>
      ),
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.IS_BUSINESS]: {
      icon: AlertIcon,
      title: (
        <>
          מנוי {selectedSubscriber} הינו עיסקי
          <br />
          יש לפנות לאיש הקשר בארגונך
          <br />
          למתן שירות
        </>
      ),
      subtitle: null,
      action: null,
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.NOT_SUBSCRIBED]: {
      icon: AlertIcon,
      title: (
        <>
          אנחנו לא מזהים שיש לך
          <br />
          מנוי סלולר בסלקום
        </>
      ),
      subtitle: (
        <>
          יכול להיות שנרשמתם עם פרטים אחרים?
          <br />
          שווה לנסות להתחבר שוב
        </>
      ),
      action: createLinkAction('הצטרפות לסלולר שלנו', () => buildUrlOpenPageSelfAndRestBlank(Config.joinCellularServiceLink)),
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
    },
    [ErrorsEnum.SUBMIT_PACKAGE_FAILED]: {
      icon: AlertIcon,
      title: (
        <>
          משהו השתבש
          <br />
          והשירות לא הותקן
        </>
      ),
      subtitle: 'נשמח לעזור עם זה',
      action: <a href={'tel:*'+ window.Config.technicalSupportPhone} style={{textDecoration: 'none'}}><FuntoneButton text={'חייגו *'+ window.Config.technicalSupportPhone + ' לנציג שירות'  } variant={'secondary'} /></a>,
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
      hideBackButton: true,
    },
    [ErrorsEnum.GENERAL_ERROR]: {
      icon: AlertIcon,
      title: (
        <>

          משהו השתבש
          <br />
          אנא נסו שוב מאוחר יותר
        </>
      ),
      subtitle: null,
      finishButton: <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={navigateToCatalog} />,
      hideBackButton: true,
    },
  };

  return errorContentMap[errorReason];
};
